import Vue from 'vue'
import App from './App.vue'
import MintUI from 'mint-ui'
import { Navbar, TabItem } from 'mint-ui';
import 'mint-ui/lib/style.css'
import '@/style/main.css'
import router from './router'
import store from './store' 
import SelectSearch from '@/components/selectSearch' 
import TableList from '@/components/tableList' 
Vue.config.productionTip = false


Vue.use(MintUI)
Vue.component('SelectSearch', SelectSearch);
Vue.component('TableList', TableList);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);

new Vue({
  render: h => h(App),
  store,
  router,
}).$mount('#app')
